import { Field } from "./field";
import { cr, md5 } from "fire-wind-water";
import { $skxhrp } from "../services";

// textLimitType: string;   // 字段正则验证类型
// textRegularExpression: any;  // 字段正则
// textLength: number;  // 字段长度
// displaySelectType: string; // 前端展示类型
// trim: boolean;  // 是否去除前后空格

declare let $sk: any;

class Text extends Field {
  verificationCodeError: boolean;
  verificationCodeDirty: boolean;
  sendCodeJson: { [label: string]: any };
  scenesKey: string;
  trim: boolean;
  sensitivDirty: boolean;
  displaySelectType = "TEXT";
  sensitivValue: string;
  verificationCode: any;

  isSensitive: any;
  textLimitType: string;
  textRegularExpression: string;

  constructor(field) {
    super(field);
    const attr = [
      "textLimitType",
      "textRegularExpression",
      "textLength",
      "isSensitive",
      "isSendSms",
      "verificationCode",
    ];
    cr.each(attr, (d) => {
      this[d] = field[d];
    });
    if (this.fieldName !== "mobile") {
      this.isSendSms = 0;
    }
    this.verificationCodeError = this.isSendSms === 1;
    this.verificationCodeDirty = false;
    if (!this.verificationCode) {
      this.verificationCode = "";
    }
    this.sendCodeJson = {
      dt: null,
      disabled: false,
      time: 0,
    };
    this.scenesKey = "";
    // 是否强制去除前后空格，默认是
    // eslint-disable-next-line no-prototype-builtins
    this.trim = field.hasOwnProperty("trim") ? field.trim : true;
    this.messages.required =
      this.fieldInfo.errorRequired || "请填写" + this.displayName;
    this.isError();
  }

  setValue(val): void {
    this.value = val;
    this.model = this.value;
    this.dirty = true;
    this.sensitivDirty = true;
    this.isError();
  }

  initValue(val): void {
    this.value = val || null;
    this.model = this.value;
    this.InitialValue = this.value;
    this.sensitivValue = val;
    this.dirty = false;
    this.sensitivDirty = false;
    this.isError();
  }

  clearValue(): void {
    this.value = null;
    this.model = null;
    this.dirty = false;
    this.sensitivDirty = false;
    this.verificationCode = null;
    this.verificationCodeDirty = false;
    this.isError();
  }

  setCode(c): void {
    this.verificationCode = c;
    this.verificationCodeDirty = true;
    this.isSendCodeError();
  }

  sendCode(key, o): void {
    this.dirty = true;
    this.error.sendCode = false;
    if (this.invalid) {
      return;
    }
    if (!this.value) {
      this.error.sendCode = true;
      this.hasError();
      return;
    }
    this.sendCodeJson.time = 60;
    this.sendCodeJson.disabled = true;
    this.sendCallback(this);
    this.scenesKey = md5.createHash(key);
    $skxhrp("api/sms/captcha/send", {
      scenesKey: this.scenesKey,
      mobile: this.value,
      ...o,
    }).then((res: any) => {
      if (res.result !== 0) {
        $sk.alert(res.desc);
        this.sendCodeJson.time = 0;
        this.sendCodeJson.disabled = false;
        this.sendCallback(this);
      } else {
        this.sendWaiting();
      }
    });
  }

  sendWaiting(): void {
    this.sendCodeJson.dt = setTimeout(() => {
      this.sendCodeJson.time -= 1;
      if (this.sendCodeJson.time <= 0) {
        clearTimeout(this.sendCodeJson.dt);
        this.sendCodeJson.disabled = false;
      } else {
        this.sendWaiting();
      }
      this.sendCallback(this);
    }, 1000);
  }

  sendCallback(o): void {
    console.log(o);
  }

  isSendCodeError(): void {
    this.verificationCodeError = false;
    if (this.verificationCode) {
      this.verificationCode.trim();
    }
    if (parseInt(this.isSendSms, 10) === 1) {
      if (this.required === 1 && !this.verificationCode) {
        this.verificationCodeError = true;
      }
    }
  }

  isError(): void {
    this.isSendCodeError();
    this.setError();
    // 如果是脱敏字段，且没有改变过初始值，不去校验
    if (
      parseInt(this.isSensitive) === 1 &&
      !this.sensitivDirty &&
      this.value === this.sensitivValue
    ) {
      if (this.value || parseInt(this.required) !== 1) {
        return;
      }
    }
    if (this.value) {
      if (this.trim) {
        this.value.trim();
      }
      if (this.textLimitType != "UNCHECK" && this.textRegularExpression) {
        const reg = new RegExp(this.textRegularExpression, "g");
        if (!reg.test(this.value)) {
          this.error.pattern = true;
        }
        if (this.textLength && this.textLength > 0) {
          if (this.value.length > this.textLength) {
            this.error.maxLength = true;
          }
        }
      }
    } else {
      if (this.required === 1) {
        this.error.required = true;
      }
    }
    this.hasError();
  }
}

export { Text };
